// Announcement bar extras: per-announcement color scheme and [timer] countdowns.

(() => {
  if (window.announcementExtrasLoaded) return;
  window.announcementExtrasLoaded = true;

  const pad = (value) => String(value).padStart(2, '0');

  const endFor = (timer) => {
    if (timer.dataset.mode === 'date' && timer.dataset.end) {
      const end = new Date(timer.dataset.end.replace(' ', 'T'));
      if (!Number.isNaN(end.getTime())) return end;
    }
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight;
  };

  const tick = () => {
    document.querySelectorAll('.announcement-timer').forEach((timer) => {
      const remaining = Math.max(0, endFor(timer) - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      timer.textContent = `${days ? `${days}d ` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    });
  };

  const applyScheme = (bar, slide) => {
    const scheme = slide?.dataset.colorScheme || bar.dataset.defaultScheme;
    bar.className = bar.className.replace(/\bcolor-\S+/g, '').trim();
    bar.classList.add(scheme);
  };

  const init = () => {
    tick();
    setInterval(tick, 1000);

    document.querySelectorAll('.utility-bar').forEach((bar) => {
      const slideshow = bar.querySelector('slideshow-component');
      const slides = bar.querySelectorAll('[data-color-scheme]');
      if (!slideshow || !slides.length) return;
      applyScheme(bar, bar.querySelector('.slideshow__slide'));
      slideshow.addEventListener('slideChanged', (event) => applyScheme(bar, event.detail.currentElement));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
